<template>
  <v-col class="flex-column d-flex text-center">
    <div v-if="small" class="mt-8"></div>
    <v-spacer></v-spacer>
    <v-card
      flat
      class="radius mx-auto"
      :class="small ? 'px-5' : 'px-12'"
      :min-width="$vuetify.breakpoint.lgAndUp ? 485 : 340"
      :max-width="$vuetify.breakpoint.lgAndUp ? 485 : 340"
    >
      <v-container fluid>
        <v-row>
          <v-col class="d-flex justify-center ma-2">
            <v-img
              src="../assets/logo_text_bellow.png"
              :max-height="small ? 80 : 105"
              contain
              max-width="110"
            ></v-img>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="8" class="ma-6 mb-0">
            <template v-if="sent">
              <p class="font-weight-bold body-2 text-center ubuntu">
                An email has been sent to your account.
              </p>
              <v-btn
                small
                depressed
                class="text-capitalize"
                outlined
                color="#FF347C"
                @click="goLogin"
                >Go To Login</v-btn
              >
            </template>
            <template v-else>
              <p class="font-weight-bold body-2 text-center ubuntu">Forgot Password?</p>
              <p class="font-weight-light caption text-center mt-3 ubuntu">
                No problem. We will send you an email with a link to restore your password.
              </p>
            </template>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-center">
            <v-form ref="form" lazy-validation @submit.prevent>
              <v-text-field
                label="Email"
                v-model="email"
                class="mx-6"
                validate-on-blur
                :rules="[rules.required, rules.email]"
              />
              <v-card-actions>
                <v-btn
                  @click="goLogin"
                  class="ma-4 text-capitalize"
                  width="120"
                  outlined
                  color="#262626"
                  >Cancel</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  class="ma-4 text-capitalize white--text"
                  width="120"
                  depressed
                  color="#FF347C"
                  @click="onClick"
                  >Send</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-spacer></v-spacer>
    <Copyright />
  </v-col>
</template>

<script>
import Copyright from "@/components/Copyright";
import { forgotPassword } from "@/api/api";

export default {
  name: "Login",
  components: {
    Copyright,
  },
  data: () => ({
    email: "",
    sent: false,
    rules: {
      email: (v) => {
        const re =
          /^(([^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+(\.[^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(v)) return true;
        return "Must be a valid e-mail.";
      },
      required: (v) => !!v || "Email required",
    },
  }),
  computed: {
    small() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted() {},
  methods: {
    goLogin() {
      window.location.assign("/app/auth/login");
    },
    async onClick() {
      if (!this.$refs.form.validate()) return;
      const response = await forgotPassword(this.email);
      if (response) {
        this.$store.commit("snackSuccess", true);
        this.sent = true;
      }
    },
  },
};
</script>
<style scoped>
.ubuntu {
  font-family: Ubuntu !important;
}
</style>
